import { render, staticRenderFns } from "./need_details.vue?vue&type=template&id=abfc3c1e&scoped=true"
import script from "./need_details.vue?vue&type=script&lang=js"
export * from "./need_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfc3c1e",
  null
  
)

export default component.exports